export enum AutocompleteVehiclesBy {
  LICENSE_PLATE = "LICENSE_PLATE",
  VIN = "VIN"
}

export enum AutocompleteRequestOrigin {
  CALC = "CALC",
  CONTRACT = "CONTRACT"
}
